import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { Command, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'

import { KeyEnter } from '@/components/ui/icons'

export type ShortcutType =
  | 'ctrl'
  | 'shift'
  | 'alt'
  | 'cmd'
  | 'enter'
  | 'plus'
  | 'minus'
  | 'esc'

const keyChipVariants = cva(
  'flex items-center gap-1 rounded h-6 px-2 justify-center text-sm',
  {
    variants: {
      variant: {
        default: 'bg-gray-500/10',
        light: 'bg-white/40',
        lighter: 'bg-white/10',
        dark: 'bg-black/10',
        destructive: 'bg-red-500/10',
        white: 'bg-white',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface KeyChipProps
  extends React.ComponentPropsWithoutRef<'div'>,
    VariantProps<typeof keyChipVariants> {
  shortcut: ShortcutType
}

export const KeyChip = ({ className, shortcut, variant }: KeyChipProps) => {
  return (
    <div className={cn(keyChipVariants({ variant, className }))}>
      {renderKey(shortcut)}
    </div>
  )
}

const renderKey = (shortcut: ShortcutType) => {
  switch (shortcut) {
    case 'ctrl':
      return <Command className="size-3" strokeWidth={1.5} />
    case 'shift':
      return <Command className="size-3" strokeWidth={1.5} />
    case 'alt':
      return <Command className="size-3" strokeWidth={1.5} />
    case 'cmd':
      return <Command className="size-3" strokeWidth={1.5} />
    case 'enter':
      return <KeyEnter className="size-3" strokeWidth={2} />
    case 'plus':
      return <Plus className="size-3" strokeWidth={2} />
    case 'minus':
      return <Command className="size-3" strokeWidth={1.5} />
    case 'esc':
      return <span className="font-mono text-sm font-semibold">Esc</span>
  }
}
